var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayer12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_447_1926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.195 -0.000135253C28.2776 0.0342306 36.3822 8.17131 36.344 18.2214C36.3077 28.2677 28.1439 36.3876 18.1301 36.3399C8.06663 36.2921 -0.045628 28.1474 0.000193159 18.1355C0.0460143 8.07012 8.17736 -0.0345011 18.195 -0.000135253ZM18.1473 31.2747C21.7137 31.227 24.7913 30.0394 27.3917 27.6415C28.0695 27.0172 28.0695 26.2439 27.4032 25.612C22.3017 20.7626 14.031 20.7702 8.92386 25.6292C8.27855 26.2439 8.28237 27.021 8.94105 27.63C11.549 30.0394 14.6401 31.2289 18.1454 31.2747H18.1473ZM23.6535 13.939C23.6535 10.9015 21.2058 8.45005 18.1683 8.4405C15.1345 8.42905 12.6373 10.932 12.6545 13.962C12.6717 16.9919 15.1403 19.4414 18.1702 19.4357C21.2039 19.4319 23.6554 16.9747 23.6535 13.939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1467 31.2767C14.6414 31.2309 11.5523 30.0414 8.94241 27.632C8.28182 27.023 8.27801 26.2459 8.92523 25.6311C14.0324 20.7722 22.3031 20.7627 27.4045 25.614C28.0689 26.2459 28.0708 27.0191 27.3931 27.6435C24.7927 30.0395 21.7151 31.229 18.1486 31.2767H18.1467Z",
    fill: "#234492"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6534 13.9412C23.6534 16.9769 21.2038 19.434 18.1701 19.4378C15.1383 19.4417 12.6716 16.994 12.6544 13.9641C12.6372 10.9323 15.1345 8.43121 18.1682 8.44267C21.2058 8.45412 23.6515 10.9056 23.6534 13.9412Z",
    fill: "#234492"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_1926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.3438,
    height: 36.34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer12);
export default __webpack_public_path__ + "static/media/Layer_1 (2).0c5abfde8f54793b902cec37e417eb75.svg";
export { ForwardRef as ReactComponent };